export default __webpack_public_path__ + "static/media/me-icon-active.12be0097.webp";